module.exports = __webpack_public_path__ + "img/logo_tib.74cc5e9a.svg";